// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__MPsBu","clinicsSelect":"TableHeading_clinicsSelect__1SG00"};